import { render, staticRenderFns } from "./UiFilter.vue?vue&type=template&id=2897c0c4&scoped=true"
import script from "./UiFilter.vue?vue&type=script&lang=js"
export * from "./UiFilter.vue?vue&type=script&lang=js"
import style0 from "./UiFilter.vue?vue&type=style&index=0&id=2897c0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897c0c4",
  null
  
)

export default component.exports